import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import notify from '@/migration/notification';
import { compose, lifecycle, setDisplayName, withState } from 'recompose';
import { bindActionCreators } from 'redux';
import { usersAction } from '@/actions';
import { paths } from '@/config';

const mapStateToProps = (state) => ({
  router: state.router,
  form: state.form.toJS(),
  users: state.users.toJS(),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...usersAction, notify, push }, dispatch);

const enhance = compose(
  setDisplayName('StripeCallback'),
  connect(mapStateToProps, mapDispatchToProps),
  withState('isLoading', 'isLoadingUpdater', true),
  lifecycle({
    async componentDidMount() {
      const { getMe, isLoadingUpdater, push } = this.props;

      try {
        await getMe();
      } catch (error) {
        push(paths.before.signin);
        notify(
          'セッションが切れました。再度、ログインを行なってください',
          'error',
          undefined,
          5
        );
      }

      // Express では return_url にリダイレクトされるだけ
      // ここに来た時点でオンボーディングは完了または保留中
      isLoadingUpdater(false);
    },
  })
);

export default enhance;
